import OptimizelySnippetLoader from './OptimizelySnippetLoader';

export default OptimizelySnippetLoader;
